/*
  viblii: the custom PDP sections (#vb-*pdp) post their product form natively, which jumps
  straight to /cart and skips the theme's mini-cart drawer and its "You may also like..."
  recommendations. This adds to the bag over AJAX instead and opens that drawer, mirroring
  Glozin's own ProductGrouped.submitProductGroup (assets/main-product.js).
  Any failure falls back to the normal form post, so the button never stops working.
*/
(function () {
  function updateCounts(c) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.innerHTML = el.classList.contains('cart-count-drawer')
        ? '(' + c.item_count + ')'
        : c.item_count > 100 ? '~' : c.item_count;
    });
    var total = document.querySelector('header-total-price');
    if (total && total.updateTotal) total.updateTotal(c);
    var freeShip = document.querySelector('free-ship-progress-bar');
    if (freeShip && freeShip.init) freeShip.init(c.items_subtotal_price);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || e.defaultPrevented) return;
    if (!form.closest('[id^="vb-"][id$="pdp"]')) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!cart || typeof cart.open !== 'function' || typeof cart.getSectionsToRender !== 'function') return;
    if (!window.routes || !window.routes.cart_add_url) return;

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.classList.add('loading'); }

    var fd = new FormData(form);
    fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
    fd.append('sections_url', window.location.pathname);

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) {
          // a real cart error (e.g. not enough stock): show it the theme's way, don't post
          if (res.j && res.j.description && typeof handleErrorMessagePopup === 'function') {
            handleErrorMessagePopup(res.j.description);
            return 'handled';
          }
          throw res.j;
        }
        cart.getSectionsToRender().forEach(function (s) {
          var el = document.getElementById(s.id);
          var html = res.j.sections && res.j.sections[s.id];
          if (!el || !html) return;
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#minicart-form');
          if (fresh) el.innerHTML = fresh.innerHTML;
        });
        if (typeof cart.cartAction === 'function') cart.cartAction();
        return fetch('/cart.json').then(function (r) { return r.json(); }).then(updateCounts).then(function () {
          if (typeof BlsLazyloadImg !== 'undefined') BlsLazyloadImg.init();
          if (typeof showMinicartAddSuccessMessage === 'function') showMinicartAddSuccessMessage(cart);
          cart.open();
          var rec = document.querySelector('.cart-recommend');
          if (rec && !rec.classList.contains('hidden-recommend')) {
            setTimeout(function () { rec.classList.add('open'); }, 800);
            // Shopify sometimes has nothing to recommend: hide the panel rather than show
            // a bare "You may also like..." heading.
            var tries = 0;
            (function check() {
              if (rec.querySelector('a[href*="/products/"]')) {
                rec.style.display = '';
                // the slider is built while the drawer is still sliding in, so it can lay out
                // at 1 card per row; re-measure once the drawer has settled (2 per row)
                var sw = rec.querySelector('.swiper');
                [0, 400, 900].forEach(function (t) {
                  setTimeout(function () { if (sw && sw.swiper) sw.swiper.update(); }, t);
                });
                return;
              }
              if (++tries > 12) { rec.style.display = 'none'; return; }
              setTimeout(check, 250);
            })();
          }
        });
      })
      .catch(function (err) {
        if (window.console) console.warn('viblii-ajax-cart: falling back to normal add', err);
        HTMLFormElement.prototype.submit.call(form);
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('loading'); }
      });
  });
})();
